import React, {useEffect, useRef, useState} from "react";
import { AnimatePresence, motion } from "framer-motion";
import { deviceType, primaryInput } from 'detect-it';
import { cursorCharVariants, cursorCircleVariants, cursorTextVariants } from "./variants";
import "./styles.css";

const CustomCursor = ({cursorText, hideCursor}) => {
  let mouseX;
  let mouseY;
  let prevCursorText;
  let jsFlag = false;

  const [hasMoved, setHasMoved] = useState(false);
  const [isCircle, setIsCircle] = useState(false);

  const secondaryCursor = useRef(null);
  const positionRef = useRef({
    mouseX: 0,
    mouseY: 0,
    destinationX: 0,
    destinationY: 0,
    distanceX: 0,
    distanceY: 0,
    key: -1,
  });

  
  useEffect(() => {
    if(deviceType !== 'touchOnly' && primaryInput=='mouse'){
      document.addEventListener("mousemove", (event) => {
        if(!hasMoved) setHasMoved(true);
        const { clientX, clientY } = event;
        mouseX = clientX;
        mouseY = clientY;

        try{
          positionRef.current.mouseX = mouseX - secondaryCursor.current.clientWidth / 2;
          positionRef.current.mouseY = mouseY - secondaryCursor.current.clientHeight / 2;
        } catch{}
      });
    }
    return () => {};
  }, []);

  useEffect(() => { 
    if(deviceType !== 'touchOnly'){
      if(!cursorText) setIsCircle(true);
      else setIsCircle(false)
    }
  }, [cursorText]
)

const mouseDown = (e) => {
  try{
    let prev;
    let custm_crsr = document.getElementById("cursor-circle");
    let test = document.getElementsByClassName("cursor-active-2");
    let test2 = document.getElementsByClassName("cursor-active");
    if (test.length || test2.length)prev = 0.75; else prev = 1;
    custm_crsr.style.transform = "scale(0.5)";
  } catch{}
}

const mouseUp = () => {
  try{
    let custm_crsr = document.getElementById("cursor-circle");
    let test = document.getElementsByClassName("cursor-active-2");
    let test2 = document.getElementsByClassName("cursor-active");
    let next;
    if (test.length || test2.length)next = 0.65; else next = 1;
    if(custm_crsr)setTimeout(() => {custm_crsr.style.transform = "";}, 200);
  } catch{}
}

useEffect(() => {
  try{
    document.addEventListener("mousedown", (e) => mouseDown(e));
    document.addEventListener("mousedown", mouseUp);
    const followMouse = () => {
      if (!jsFlag){
        jsFlag = true;
      }
      positionRef.current.key = requestAnimationFrame(followMouse);
      const {
        mouseX,
        mouseY,
        destinationX,
        destinationY,
        distanceX,
        distanceY,
      } = positionRef.current;
      if ((!destinationX || !destinationY)) {
        positionRef.current.destinationX = mouseX;
        positionRef.current.destinationY = mouseY;
      } else {
        positionRef.current.distanceX = (mouseX - destinationX) * 0.1;
        positionRef.current.distanceY = (mouseY - destinationY) * 0.1;
        if (Math.abs(positionRef.current.distanceX) + Math.abs(positionRef.current.distanceY) < 0.001) {
          positionRef.current.destinationX = mouseX;
          positionRef.current.destinationY = mouseY;
        } else {
          positionRef.current.destinationX += distanceX;
          positionRef.current.destinationY += distanceY;
        }
      }
      try{
        secondaryCursor.current.style.transform = `translate3d(${destinationX}px, ${destinationY}px, 0)`;
        prevCursorText = cursorText;
      }
      catch(err){
      }
    };
    if(deviceType !== 'touchOnly')
      followMouse();
  }catch{}
    return() => {
      try{
        document.removeEventListener("mousedown", mouseDown);
        document.removeEventListener("mousedown", mouseUp);
      }catch{}
    }
  }, []);

  return (
    <>
    {
      deviceType !== 'touchOnly' &&
      <div className={`cursor-wrapper default ${hideCursor && 'hide'}`}>
          <motion.div className="secondary-cursor" ref={secondaryCursor}
            key={"cc-wrapper"+isCircle+cursorText}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <AnimatePresence mode="wait">
              {
                !isCircle &&
                  <motion.span
                    key={"cursor-text-wrapper"+"_"+cursorText}
                    id="cursor-text"
                    variants={cursorTextVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    style={{transform: "translate(0%, -100%)"}}
                  >
                    { 
                      cursorText.split("").flat().map((char, idx) => {
                        return(
                            char == "_" ?
                              <motion.span>&nbsp;</motion.span>
                            :
                            <motion.span
                              key={"cursor-char"+idx}
                              style={{display: "inline-block"}}
                              variants={cursorCharVariants}
                              custom={idx}
                            >
                              {char}
                            </motion.span>
                              
                        )
                      })
                    
                    }
                  </motion.span>
              }
              </AnimatePresence>
              <AnimatePresence mode="wait">
              { isCircle &&
                <motion.span
                  id="cursor-circle"
                  key={"cursor-circle-wrapper"}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  variants={cursorCircleVariants}
                ></motion.span>
              }
            </AnimatePresence>
            </motion.div>
      </div>
    }
  </>
  );
};

export default CustomCursor;